import React from 'react';

const SimCard2 = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_4418_10038)">
        <path
          d="M16 12.6899V18.0799C16 20.4199 14.44 21.9699 12.11 21.9699H5.89C3.56 21.9699 2 20.4199 2 18.0799V10.3099C2 7.96992 3.56 6.41992 5.89 6.41992H9.72C10.75 6.41992 11.74 6.82992 12.47 7.55992L14.86 9.93992C15.59 10.6699 16 11.6599 16 12.6899Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22 8.2507V13.6407C22 15.9707 20.44 17.5307 18.11 17.5307H16V12.6907C16 11.6607 15.59 10.6707 14.86 9.9407L12.47 7.5607C11.74 6.8307 10.75 6.4207 9.72 6.4207H8V5.8607C8 3.5307 9.56 1.9707 11.89 1.9707H15.72C16.75 1.9707 17.74 2.3807 18.47 3.1107L20.86 5.5007C21.59 6.2307 22 7.2207 22 8.2507Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4418_10038">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SimCard2;
